// extracted by mini-css-extract-plugin
export var modalFooter = "_ki-0";